import { create } from 'zustand';
import type { CommentShapeLocation } from '../domains/comments/models/Comment';

export type CommentPromptState = {
  diagram: {
    x: number;
    y: number;
  };
  local: {
    x: number;
    y: number;
  };
  shapeId?: string | null;
  locOnShape?: CommentShapeLocation | null;
};

interface CommentOverlayState {
  prompt: CommentPromptState | null;
  draft: string;
  activeCommentId: string | null;
  openPrompt: (prompt: CommentPromptState) => void;
  closePrompt: () => void;
  setDraft: (draft: string) => void;
  selectComment: (commentId: string | null) => void;
  clearActiveComment: () => void;
}

export const useCommentOverlayStore = create<CommentOverlayState>((set) => ({
  prompt: null,
  draft: '',
  activeCommentId: null,
  openPrompt: (prompt) => set({ prompt, draft: '', activeCommentId: null }),
  closePrompt: () => set({ prompt: null, draft: '' }),
  setDraft: (draft) => set({ draft }),
  selectComment: (commentId) => set({ activeCommentId: commentId, prompt: null, draft: '' }),
  clearActiveComment: () => set({ activeCommentId: null }),
}));
